// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82e605d4","239":"0cacac2c","453":"f3ae13be","455":"10ec2a25"}[chunkId] + ".chunk.js";
};